import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["children", "className", "onSubmit"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { useState } from "react";
import { setDocDataUpdated, showNotification } from "../../redux/commonSlice";
import { useAppDispatch } from "../../store/hooks";
import { GoogleAnlyticsErrorLog } from "../../utils/utils";
import { getLocalStorageItem } from "../../utils/storageHelper";
import { LOCAL_STORAGE_KEYS } from "../../constants";
export var MuiUseForm = function (initialFValues) {
    var validateOnChange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var validate = arguments.length > 2 ? arguments[2] : undefined;
    var isFromCustomerInfo = arguments.length > 3 ? arguments[3] : undefined;
    var _a = useState(initialFValues), values = _a[0], setValues = _a[1];
    var _b = useState({}), errors = _b[0], setErrors = _b[1];
    var dispatch = useAppDispatch();
    var profileData = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA);
    var handleInputChange = function (e) {
        var _a, _b;
        var _c = e.target, name = _c.name, value = _c.value;
        setValues(_objectSpread(_objectSpread({}, values), {}, (_a = {},
            _a[name] = value,
            _a)));
        if (!isFromCustomerInfo) {
            dispatch(setDocDataUpdated(true));
        }
        if (validateOnChange)
            validate((_b = {},
                _b[name] = value,
                _b));
    };
    var handleInputSearchChanges = function (e, target) {
        var _a, _b;
        var _target$target, _target$target2;
        var name = target.target.name;
        var value = (target === null || target === void 0 || (_target$target = target.target) === null || _target$target === void 0 ? void 0 : _target$target.value) || (target === null || target === void 0 || (_target$target2 = target.target) === null || _target$target2 === void 0 || (_target$target2 = _target$target2.value) === null || _target$target2 === void 0 ? void 0 : _target$target2.id);
        // const { name, value } = e.target;
        setValues(_objectSpread(_objectSpread({}, values), {}, (_a = {},
            _a[name] = value,
            _a)));
        if (validateOnChange)
            validate((_b = {},
                _b[name] = value,
                _b));
    };
    var handleSwitchChange = function (e) {
        var _a;
        var _b = e.target, name = _b.name, checked = _b.checked;
        if (checked || !checked) {
            setValues(_objectSpread(_objectSpread({}, values), {}, (_a = {},
                _a[name] = checked,
                _a)));
        }
    };
    var handleServerSideErrors = function (_data) {
        if (_data) {
            var code = _data.code, error = _data.error;
            if (_data !== null && _data !== void 0 && _data.message) {
                GoogleAnlyticsErrorLog(profileData, 'ClientSide', _data === null || _data === void 0 ? void 0 : _data.message);
                dispatch(showNotification({
                    isOpen: true,
                    message: _data === null || _data === void 0 ? void 0 : _data.message,
                    type: "error"
                }));
            }
            else if (code === "PAYLOADVALERR") {
                var _error$;
                (_error$ = error[0]) === null || _error$ === void 0 || _error$.map(function (_it) {
                    var _Object$keys;
                    var missingProperty = (_it === null || _it === void 0 ? void 0 : _it.params).missingProperty;
                    var message = _it.message, keyword = _it.keyword, instancePath = _it.instancePath;
                    var initial = initialFValues;
                    switch (keyword) {
                        case "required":
                            GoogleAnlyticsErrorLog(profileData, 'ClientSide', message);
                            dispatch(showNotification({
                                isOpen: true,
                                message: message,
                                type: "error"
                            }));
                            break;
                        case "errorMessage":
                            var field_1 = instancePath.replace(/\\|\//g, '');
                            var abc = (_Object$keys = Object.keys) === null || _Object$keys === void 0 || (_Object$keys = _Object$keys.call(Object, values)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.find(function (it) { return it === field_1; });
                            if (abc) {
                                setErrors(function (prevErrors) {
                                    var _a;
                                    return _objectSpread(_objectSpread({}, prevErrors), {}, (_a = {},
                                        _a[field_1] = message,
                                        _a));
                                });
                            }
                            else {
                                GoogleAnlyticsErrorLog(profileData, 'ClientSide', "".concat(field_1, ": ").concat(message));
                                dispatch(showNotification({
                                    isOpen: true,
                                    message: "".concat(field_1, ": ").concat(message),
                                    type: "error"
                                }));
                            }
                            break;
                        case "type":
                            var _field_1 = instancePath.replace(/\\|\//g, '');
                            setErrors(function (prevErrors) {
                                var _a;
                                return _objectSpread(_objectSpread({}, prevErrors), {}, (_a = {},
                                    _a[_field_1] = message,
                                    _a));
                            });
                            break;
                        default:
                            console.log('default');
                            break;
                    }
                });
            }
        }
    };
    var resetForm = function () {
        setValues(initialFValues);
        setErrors({});
    };
    return {
        values: values,
        setValues: setValues,
        errors: errors,
        setErrors: setErrors,
        handleInputChange: handleInputChange,
        resetForm: resetForm,
        handleSwitchChange: handleSwitchChange,
        handleInputSearchChanges: handleInputSearchChanges,
        handleServerSideErrors: handleServerSideErrors
    };
};
export var MuiForm = function (props) {
    var children = props.children, className = props.className, onSubmit = props.onSubmit, other = _objectWithoutProperties(props, _excluded);
    return /*#__PURE__*/ React.createElement("form", _extends({
        className: className,
        onSubmit: onSubmit,
        autoComplete: "off"
    }, other), props.children);
};
